import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Ensure your BASE_URL is defined correctly
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const AddLeave = () => {
    const [staffId, setStaffId] = useState('');
    const [staffList, setStaffList] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [reason, setReason] = useState('');
    const [status, setStatus] = useState('Pending');
    const navigate = useNavigate();

    // Fetch staff list on mount
    useEffect(() => {
        fetch('https://pbhrm.com/api/staff')
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setStaffList(data.data);
                } else {
                    console.error('Failed to fetch staff list');
                }
            })
            .catch(error => {
                console.error('Error fetching staff list:', error);
            });
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();

        const leaveData = {
            staff_id: staffId,
            start_date: startDate,
            end_date: endDate,
            reason,
            status,
        };

        fetch(`${BASE_URL}leaves`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(leaveData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Leave added successfully'
                    });
                    navigate('/LeaveList');
                } else {
                    alert('Failed to create leave. Please try again.');
                }
            })
            .catch(error => {
                console.error('Error creating leave:', error);
                alert('An error occurred. Please try again later.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Leave</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Add Leave Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="staffId" className="form-label">Select Staff</label>
                                        <select
                                            id="staffId"
                                            className="form-control"
                                            value={staffId}
                                            onChange={(e) => setStaffId(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Staff</option>
                                            {staffList.map(staff => (
                                                <option key={staff.id} value={staff.id}>
                                                    {staff.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="startDate" className="form-label">Start Date</label>
                                        <input
                                            type="date"
                                            id="startDate"
                                            className="form-control"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="endDate" className="form-label">End Date</label>
                                        <input
                                            type="date"
                                            id="endDate"
                                            className="form-control"
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="reason" className="form-label">Reason</label>
                                        <textarea
                                            id="reason"
                                            className="form-control"
                                            value={reason}
                                            onChange={(e) => setReason(e.target.value)}
                                            placeholder="Enter reason for leave"
                                            rows="3"
                                            required
                                        ></textarea>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="status" className="form-label">Status</label>
                                        <select
                                            id="status"
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                            required
                                        >
                                            <option value="Pending">Pending</option>
                                            <option value="Approved">Approved</option>
                                            <option value="Rejected">Rejected</option>
                                        </select>
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Add Leave</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddLeave;
